import React, { useEffect, useState } from "react";
import { Table } from 'rsuite';
const {Column,HeaderCell,Cell}=Table;
type attributes = {
  members:any,
  
}
export const TeamMembers=(props:attributes)=>{
    return(
      <Table
      height={300}
      data={props.members}
    
  >
    <Column resizable flexGrow={100} align="center" >
      <HeaderCell>ID</HeaderCell>
      <Cell dataKey="EmployeeId" />
    </Column>
    <Column  resizable flexGrow={250} >  
      <HeaderCell>Name</HeaderCell>
      <Cell dataKey="EmployeeName" />
    </Column>

    <Column flexGrow={150} >
      <HeaderCell>PROCESS</HeaderCell>
      <Cell dataKey="Process" />
    </Column>
    <Column flexGrow={120}>
      <HeaderCell>ALLOCATION%</HeaderCell>
      <Cell dataKey="allocation" />
    </Column>
    <Column flexGrow={120}>
      <HeaderCell>BUFFER%</HeaderCell>
      <Cell dataKey="buffer" />
    </Column>
  </Table>
    )
}